/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 5V9V12V18L6 15"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13 13H16L13 18H16M13 10V8.125M13 8.125V6.5C13 5.67157 13.6716 5 14.5 5C15.3284 5 16 5.67157 16 6.5V8.125M13 8.125H16M16 8.125V10M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="6"
				fill="currentColor"
			/>
			<path
				d="M6 15L9 18V12V9V5M13 13H16L13 18H16M13 10V8.125M13 8.125V6.5C13 5.67157 13.6716 5 14.5 5C15.3284 5 16 5.67157 16 6.5V8.125M13 8.125H16M16 8.125V10M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.52606 1.90396C5.80953 1.25 7.48969 1.25 10.85 1.25H13.15C16.5103 1.25 18.1905 1.25 19.4739 1.90396C20.6029 2.4792 21.5208 3.39709 22.096 4.52606C22.75 5.80953 22.75 7.48969 22.75 10.85V13.15C22.75 16.5103 22.75 18.1905 22.096 19.4739C21.5208 20.6029 20.6029 21.5208 19.4739 22.096C18.1905 22.75 16.5103 22.75 13.15 22.75H10.85C7.48969 22.75 5.80953 22.75 4.52606 22.096C3.39708 21.5208 2.4792 20.6029 1.90396 19.4739C1.25 18.1905 1.25 16.5103 1.25 13.15V10.85C1.25 7.48969 1.25 5.80953 1.90396 4.52606C2.4792 3.39708 3.39709 2.4792 4.52606 1.90396ZM9.75 4.99998C9.75 4.58577 9.41421 4.24999 9 4.24999C8.58579 4.24999 8.25 4.58577 8.25 4.99998V16.1893L6.53033 14.4697C6.23744 14.1768 5.76256 14.1768 5.46967 14.4697C5.17678 14.7625 5.17678 15.2374 5.46967 15.5303L8.46967 18.5303C8.68417 18.7448 9.00676 18.809 9.28701 18.6929C9.56726 18.5768 9.75 18.3033 9.75 18V4.99998ZM14.5 4.24999C13.2574 4.24999 12.25 5.25735 12.25 6.49998V8.12498V9.99998C12.25 10.4142 12.5858 10.75 13 10.75C13.4142 10.75 13.75 10.4142 13.75 9.99998V8.87498H15.25V9.99998C15.25 10.4142 15.5858 10.75 16 10.75C16.4142 10.75 16.75 10.4142 16.75 9.99998V8.12498V6.49998C16.75 5.25735 15.7426 4.24999 14.5 4.24999ZM15.25 6.49998V7.37499H13.75V6.49998C13.75 6.08577 14.0858 5.74998 14.5 5.74998C14.9142 5.74998 15.25 6.08577 15.25 6.49998ZM13 12.25C12.5858 12.25 12.25 12.5858 12.25 13C12.25 13.4142 12.5858 13.75 13 13.75H14.6754L12.3569 17.6141C12.2179 17.8458 12.2142 18.1344 12.3474 18.3695C12.4805 18.6046 12.7298 18.75 13 18.75H16C16.4142 18.75 16.75 18.4142 16.75 18C16.75 17.5858 16.4142 17.25 16 17.25H14.3246L16.6431 13.3859C16.7821 13.1542 16.7858 12.8656 16.6526 12.6305C16.5195 12.3953 16.2702 12.25 16 12.25H13Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 9.5V9V9C22 8.07116 22 7.60674 21.9487 7.21684C21.5942 4.52444 19.4756 2.40579 16.7832 2.05133C16.3933 2 15.9288 2 15 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22H15C15.9288 22 16.3933 22 16.7832 21.9487C19.4756 21.5942 21.5942 19.4756 21.9487 16.7832C22 16.3933 22 15.9288 22 15V15V14.5M6 15L9 18V12V9V5M13 13H16L13 18H16M13 10V8.125M13 8.125V6.5C13 5.67157 13.6716 5 14.5 5C15.3284 5 16 5.67157 16 6.5V8.125M13 8.125H16M16 8.125V10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 15L9 18V12V9V5M13 13H16L13 18H16M13 10V8.125M13 8.125V6.5C13 5.67157 13.6716 5 14.5 5C15.3284 5 16 5.67157 16 6.5V8.125M13 8.125H16M16 8.125V10M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M10.85 1.25C7.48969 1.25 5.80953 1.25 4.52606 1.90396C3.39709 2.4792 2.4792 3.39708 1.90396 4.52606C1.25 5.80953 1.25 7.48969 1.25 10.85L1.25 13.15C1.25 16.5103 1.25 18.1905 1.90396 19.4739C2.4792 20.6029 3.39708 21.5208 4.52606 22.096C5.80953 22.75 7.48969 22.75 10.85 22.75H13.15C16.5103 22.75 18.1905 22.75 19.4739 22.096C20.6029 21.5208 21.5208 20.6029 22.096 19.4739C22.75 18.1905 22.75 16.5103 22.75 13.15V10.85C22.75 7.48969 22.75 5.80953 22.096 4.52606C21.5208 3.39709 20.6029 2.4792 19.4739 1.90396C18.1905 1.25 16.5103 1.25 13.15 1.25L10.85 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9 4.25C9.41421 4.25 9.75 4.58578 9.75 5V18C9.75 18.3033 9.56727 18.5768 9.28701 18.6929C9.00676 18.809 8.68417 18.7448 8.46968 18.5303L5.46968 15.5303C5.17678 15.2374 5.17678 14.7626 5.46968 14.4697C5.76257 14.1768 6.23744 14.1768 6.53033 14.4697L8.25001 16.1893V5C8.25001 4.58578 8.58579 4.25 9 4.25ZM12.25 6.5C12.25 5.25736 13.2574 4.25 14.5 4.25C15.7426 4.25 16.75 5.25736 16.75 6.5V8.125V10C16.75 10.4142 16.4142 10.75 16 10.75C15.5858 10.75 15.25 10.4142 15.25 10V8.87499H13.75V10C13.75 10.4142 13.4142 10.75 13 10.75C12.5858 10.75 12.25 10.4142 12.25 10V8.125V6.5ZM13.75 7.375H15.25V6.5C15.25 6.08578 14.9142 5.74999 14.5 5.74999C14.0858 5.74999 13.75 6.08578 13.75 6.5V7.375ZM12.25 13C12.25 12.5858 12.5858 12.25 13 12.25H16C16.2702 12.25 16.5195 12.3953 16.6526 12.6305C16.7858 12.8656 16.7821 13.1542 16.6431 13.3859L14.3246 17.25H16C16.4142 17.25 16.75 17.5858 16.75 18C16.75 18.4142 16.4142 18.75 16 18.75H13C12.7298 18.75 12.4805 18.6046 12.3474 18.3695C12.2142 18.1344 12.2179 17.8458 12.3569 17.6141L14.6754 13.75H13C12.5858 13.75 12.25 13.4142 12.25 13Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
